/** Nazwy zewnętrzne właściwości i wartości opcji — locale Globalize (m.in. marketplace’y Amazon EU). */
const property_langs = [
  { code: "pl", flag: "pl", name: "Polski" },
  { code: "de", flag: "de", name: "Niemiecki" },
  { code: "en", flag: "gb", name: "Angielski (UK)" },
  { code: "fr", flag: "fr", name: "Francuski" },
  { code: "es", flag: "es", name: "Hiszpański" },
  { code: "it", flag: "it", name: "Włoski" },
  { code: "nl", flag: "nl", name: "Holenderski" },
  { code: "sv", flag: "se", name: "Szwedzki" },
  { code: "bg", flag: "bg", name: "Bułgarski" },
  { code: "ro", flag: "ro", name: "Rumuński" },
  { code: "hu", flag: "hu", name: "Węgierski" },
];

export default property_langs;
